export const envBasics = {
    production: false,
    apiEndpoint: 'http://tsned.localhost:81/',
    isApp: false,
    development: false,
    googleMapsKey: 'AIzaSyBDvXGNcqH1tWNCwwzDThOmG3ihggdmoUk',
};
